import { render, staticRenderFns } from "./CurrentScore.vue?vue&type=template&id=86b74bd8&scoped=true&"
import script from "./CurrentScore.vue?vue&type=script&lang=js&"
export * from "./CurrentScore.vue?vue&type=script&lang=js&"
import style0 from "./CurrentScore.vue?vue&type=style&index=0&id=86b74bd8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86b74bd8",
  null
  
)

export default component.exports